export const SIDEBAR_WIDTH = 300
export const popupElementId = 'c-map-popover-id'
// Cache key for the map zoom level
export const MAP_BOUNDS_CACHE_KEY = 'map-bounds'
